export default function CoffeeMaker() {
    return (
        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_10719_2935)">
                <path
                    d="M13 27V5.88889C13 5.39797 12.602 5 12.1111 5C8.18375 5 5 8.18375 5 12.1111V25.5C5 26.3284 5.67157 27 6.5 27H13Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M27 20.75C27.4142 20.75 27.75 20.4142 27.75 20C27.75 19.5858 27.4142 19.25 27 19.25V20.75ZM24 20.75H27V19.25H24V20.75Z" fill="black" />
                <path
                    d="M24 11L24 10C24 7.79086 22.2091 6 20 6L13 6L13 11L24 11Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M22 14L22 11L18 11L18 14L22 14Z" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path
                    d="M24 20.5L24 19L17 19L17 20.5C17 22.433 18.567 24 20.5 24C22.433 24 24 22.433 24 20.5Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M13 27L26.4 27C26.7314 27 27 26.7314 27 26.4C27 25.0745 25.9255 24 24.6 24L13 24L13 27Z"
                    stroke="black"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_10719_2935">
                    <rect width="32" height="32" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
